"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setProject = exports.projectName = void 0;
var path_1 = require("path");
var util_1 = require("util");
var helper_1 = require("@kcutils/helper");
var state_1 = require("./state");
exports.projectName = "example";
var setProject = function (name) {
    exports.projectName = name;
};
exports.setProject = setProject;
var Throwable = /** @class */ (function (_super) {
    __extends(Throwable, _super);
    function Throwable(code, name, message, stack, deadly) {
        if (deadly === void 0) { deadly = true; }
        var _this = _super.call(this, message !== null && message !== void 0 ? message : "something went wrong") || this;
        _this.code = code;
        _this.deadly = deadly;
        var obj = { stack: [] };
        var orig = Error.prepareStackTrace; // save original prepare method
        Error.prepareStackTrace = function (_, stack) { return stack; };
        Error.captureStackTrace(obj, Throwable);
        var rawStack = obj.stack; // eslint-disable-line @typescript-eslint/no-explicit-any
        Error.prepareStackTrace = orig; // revert original method
        // Lets make our JSON object.
        _this._stack = [];
        for (var _i = 0, rawStack_1 = rawStack; _i < rawStack_1.length; _i++) {
            var frame = rawStack_1[_i];
            _this._stack.push({
                path: new helper_1.path.Paths(frame.getFileName()),
                typename: frame.getTypeName(),
                linenum: frame.getLineNumber(),
                colmnum: frame.getColumnNumber(),
                funcname: frame.getFunctionName(),
                method: frame.getMethodName(),
            });
        }
        if (name !== undefined)
            _this.name = name;
        if (stack !== undefined)
            _this.stack = stack;
        Object.setPrototypeOf(_this, Throwable.prototype);
        return _this;
    }
    Throwable.build = function (state, message) {
        return new Throwable(state.code, state.name, message, undefined, state.type === state_1.ThrowStateType.WARN ? false : true);
    };
    Throwable.from = function (error, deadly) {
        if (deadly === void 0) { deadly = true; }
        if (typeof error === "object" && typeof error.code === "number")
            return error;
        return new Throwable(-1, error.name, error.message, error.stack, deadly);
    };
    Throwable.fn = function (state, message) {
        var templates = message;
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return Throwable.build(state, templates ? util_1.format.apply(void 0, __spreadArrays([templates], args.filter(function (v) { return helper_1.generic.isExist(v); }))) : templates);
        };
    };
    Throwable.prototype.getDevelopmentFormatted = function () {
        var msg = this.name + "(" + this.code + "): " + this.message + "\n";
        msg += "stacks:\n";
        var stacks = this._stack.map(function (s) {
            var _a, _b;
            var typename = s.typename ? s.typename + "." : "";
            var funcname = (_b = (_a = s.funcname) !== null && _a !== void 0 ? _a : s.method) !== null && _b !== void 0 ? _b : "<anonymous>";
            var name = "" + typename + funcname;
            var buildDir = function (regex, start) {
                var _a;
                var rootdir = (_a = s.path.after(regex, start)) !== null && _a !== void 0 ? _a : s.path.at(-1);
                var dir = s.path.after(regex, start + 1);
                if (!dir)
                    return "<" + rootdir + ">";
                else
                    return "<" + rootdir + ">/" + dir;
            };
            var filename = "";
            var registry = /registry\.npmjs\.org/;
            var nodeModules = /node_modules/;
            if (s.path.includes(registry)) {
                filename = buildDir(registry, 1);
            }
            else if (s.path.includes(nodeModules)) {
                filename = buildDir(nodeModules, 1);
            }
            else {
                filename = buildDir(new RegExp(exports.projectName), 0);
            }
            var linenum = s.linenum ? ":" + s.linenum : "";
            var colnum = s.colmnum ? ":" + s.colmnum : "";
            if (s.path.isFileExist) {
                filename += path_1.sep;
                filename += "" + s.path.filename;
            }
            return {
                name: name,
                filename: filename,
                linenum: linenum,
                colnum: colnum,
            };
        });
        var maximum = stacks.reduce(function (p, c) { return (c.name.length > p ? c.name.length : p); }, 0);
        msg += "" + stacks
            .map(function (s) { return "  - " + helper_1.string.padEnd(s.name, maximum) + " " + s.filename + s.linenum + s.colnum; })
            .join("\n");
        return msg;
    };
    Throwable.prototype.getProductionFormatted = function () {
        return this.name + "(" + this.code + "): " + this.message;
    };
    Throwable.prototype.equals = function (e) {
        return e.code === this.code && e.name === this.name;
    };
    Throwable.prototype.toString = function () {
        if (helper_1.env.isProduction())
            return this.getProductionFormatted();
        else
            return this.getDevelopmentFormatted();
    };
    return Throwable;
}(Error));
exports.default = Throwable;
//# sourceMappingURL=throwable.js.map